import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { LaunchProvider, useLaunch } from "@/context/LaunchContext";
import { WalletProvider, useWallet } from "@/context/WalletContext";
import LaunchingSoon from "@/components/LaunchingSoon";
import BottomNav from "@/components/BottomNav";

import Onboarding from "@/pages/Onboarding";
import CreateWallet from "@/pages/CreateWallet";
import ImportWallet from "@/pages/ImportWallet";
import Unlock from "@/pages/Unlock";
import Portfolio from "@/pages/Portfolio";
import Send from "@/pages/Send";
import Receive from "@/pages/Receive";
import Activity from "@/pages/Activity";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";

function Loader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#1F2430] border-t-neon" />
    </div>
  );
}

function Landing() {
  const { walletExists, isUnlocked } = useWallet();
  if (!walletExists) return <Navigate to="/onboarding" replace />;
  if (!isUnlocked) return <Navigate to="/unlock" replace />;
  return <Navigate to="/portfolio" replace />;
}

function Layout() {
  const { isUnlocked } = useWallet();
  if (!isUnlocked) return <Navigate to="/" replace />;
  return (
    <div className="cw-shell">
      <div className="flex-1 overflow-y-auto pb-2">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}

function GatedApp() {
  const { enabled, loading } = useLaunch();
  if (loading) return <Loader />;
  if (!enabled) return <LaunchingSoon />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/create" element={<CreateWallet />} />
      <Route path="/import" element={<ImportWallet />} />
      <Route path="/unlock" element={<Unlock />} />
      <Route element={<Layout />}>
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/send" element={<Send />} />
        <Route path="/receive" element={<Receive />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <>
      <div className="cw-ambient" />
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#12141A", border: "1px solid #1F2430", color: "#F3F4F6" } }} />
      <LaunchProvider>
        <WalletProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="/*" element={<GatedApp />} />
            </Routes>
          </BrowserRouter>
        </WalletProvider>
      </LaunchProvider>
    </>
  );
}
